(function () {
    'use strict';

    angular
        .module('localization')
        .config(config);

    function config($translateProvider) {

        var data = {
            settings: {
                "title": "Postavke",
                "tabAccountHR": "Korisnički profil",
                "tabNotifications": "Obavijesti",
                "tabSecurity": "NA",
                "contactInfo": "Osobni podaci",
                "contactInfoBtn": "Promijeni",
                "contactInfoConfirmBtn": "Potvrdi",
                "contactInfoCancelBtn": "Otkaži",
                "contactInfoName": "Ime",
                "contactInfoAddress": "Adresa",
                "contactInfoPhone": "Telefon",
                "blocades": "Blokade",
                "blockLogin": "Blokiranje logiranja u internet bankarstvo",
                "blockMobile": "Blokiranje logiranja u mobilno bankarstvo",
                "blockPayment": "Blokiranje kartice za plaćanje",
                "accountSettings": "Postavke računa",
                "defaultAccount": "Podrazumijevani račun",
                "statementsDelivery": "Dostava izvoda",
                "statementsDeliveryPaper": "Dostava izvoda na kućnu adresu",
                "statementsDeliveryElectronic": "Dostava izvoda Internet bankarstvom",
                "messagesSettings": "Postavke poruka",
                "messagesSettingsLabel": "Označite ako želite da sve poruke od banke primate i na email",
                "securitySettings": "Sigurnosne postavke",
                "transactionsConfirmation": "Potvrda o transakcijama",
                "transactionsConfirmationSMS": "Slanjem SMS-a na mobitel",
                "transactionsConfirmationOTP": "Generisanjem jednokratne zaporke",
                "notificationSettings": "Postavke obaviještenja",
                "gsm":"GSM",
              "street": "Ulica",
              "houseNumber": "Kućni broj",
              "postalCode": "Poštanski broj",
              "city": "Grad",
              "streetRequiredErrMsg": "Unos ulice je obavezan!",
              "houseNumRequiredErrMsg": "Unos kućnog broja je obavezan!",
              "cityOrPostalCodeRequiredErrMsg": "Unos grada ili poštanskog broja je obavezan!",
              "emailRequiredErroMsg": "e-mail unos je obavezan!",
              "invalidEmailRequiredErroMsg": "e-mail je neispravan!",
              "showNotificationFor":"Želim primati obavijesti:",
              "notificationSmsNumber":"SMS broj za isporuku obavjesti:",
              "notificationMailAddress":"Email adresa za isporuku obavjesti:",
              notifs: {
                SignForeignPaymentSMS: 'Obavijest o potpisu deviznog naloga',
                SignPaymentOrderLimitSMS: 'Obavijest o potpisanom platnom nalogu u iznosu većem od limita',
                RejectedPaymentOrderSMS: 'Obavijest o odbijenom platnom nalogu',
                LoginFromAnotherBrowserSMS: 'Obavijest u slučaju prijave s drugog browsera',
                LoginFromAnotherCountrySMS: 'Obavijest u slučaju prijave iz druge države',
                MinimumAmountDebitedPerCard: 'Obavijest o trošku kreditne kartice',
                MaturityOfTheLoan: 'Obavijest o dospijeću rate kredita',
                LimitChangesSMS: 'Obavijest o promjeni limita'
              },
              "notificationInfo": "Vaš zahtjev je uspješno poslan"
            }
        };

        $translateProvider.translations('hr', data);

    }
} ());
